export default __webpack_public_path__ + "media/images/ko-7914a0a656a260d31b46a7c663117b12.png";